'use client';

import { useState } from 'react';

import CarouselTitle from './CarouselTitle';
import TwoStepStepper from './TwoStepStepper';
import CarouselCards from './CarouselCards';

export default function CarouselItems({ sortedCards, containerID, title }) {
  const [scrolledToLeft, setScrolledToLeft] = useState(true);
  const handleScroll = () => {
    const scrollContainer = document.getElementById(containerID);
    if (scrollContainer.scrollLeft === 0) {
      setScrolledToLeft(true);
    } else if (scrollContainer.scrollLeft + scrollContainer.clientWidth === scrollContainer.scrollWidth) {
      setScrolledToLeft(false);
    }
  };
  return (
    <>
      {title && <CarouselTitle title={title} id={containerID} />}
      <TwoStepStepper scrolledToLeft={scrolledToLeft} />
      <CarouselCards containerID={containerID} sortedCards={sortedCards} handleScroll={handleScroll} />
    </>
  );
}
